module.exports = "/assets/data/c449c566b9d1d6c173cc17aa08b7ebd7-BS48.data.json";